import { configureStore } from "@reduxjs/toolkit";
import { api } from "../features/api/apiSlice";
import { cmsApi } from "../features/api/cmsApiSlice";
import { eventsApi } from "../features/eventsApi";
import { fileApi } from "../features/fileApi";
import memberReducer from "../features/member/memberSlice";
import { rtkQueryErrorLogger } from "../utils/errorHandler";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [cmsApi.reducerPath]: cmsApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    member: memberReducer,
    // other reducers...
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(api.middleware)
      .concat(fileApi.middleware)
      .concat(cmsApi.middleware)
      .concat(eventsApi.middleware)
      .concat(rtkQueryErrorLogger), // Add global error handler
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
